export const survivalGuideNodeName = "Survival guide 🤺";
export const noFrillsNodeName = "No frills 🥫";
export const dollaramaNodeName = "Dollarama 💲";
export const iFeelNodeName = `I feel 😌`;
export const utterancesNodeName = `(Utterances) Part Two`;
export const diaryEntriesNodeName = `Diary Entries`;
